import createRoute from '@widesk-ui/tools/createRoute';
import TagModel    from '@models/website/TagModel';

const route = createRoute.dashboardFromModel(
	TagModel,
	'TagDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
